//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { EnterOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

//  -- Components ---------------------
import { Checkbox, Input as InputArea, Menu, Dropdown } from 'antd';

//  -- Constants ----------------------
import { Button, IconButton, Modal } from '@mui/material';
import { Snackbar } from '@mui/material';
import {
  Add,
  Close,
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  MenuOutlined,
  ChevronLeft,
  ChevronRight,
} from '@mui/icons-material';
import ResizeAndDragabble from "components/ResizeAndDraggableWidget";

import { Alert } from '@mui/material';

import TextArea from 'antd/lib/input/TextArea';
import { DeleteModal } from 'components/Dialog';
import { filter, find, get, map, sortBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { usePhrases } from 'store/Phrases/selectors';
import {
  handleCreatePhrases,
  handleDeletePhrases,
  handleListPhrasesNew,
  setDataPhrases,
  handleGeneratePhrasesWithAI,
  handleListPhrasesStud,
  handleGetStudentPhraseCount,
} from 'store/Phrases/thunks';
import Loading from '../../../../components/Loading';
import TextReader from '../../../../components/Reader';
import { useAudio } from 'utils/context/AudioProvider';
import { setAudioChecker } from 'store/audio/actions';
import QnALoader from '../../../../components/VocabQnAModal/QnALoader';
import { useExams } from 'store/exams/selectors';
import { useFocusOutside } from '../../../../components/OnClickOutside';
import { handleListVocabularyCogStud } from 'store/cogantes/thunks';
import CognateAiLoader from '../../../../components/ebook/cogantes/cognateAiModal';
import { useOrientation } from '../../../../components/hooks';
import { question_type_generate_more } from 'utils/config/reference';
import { useClassUsers } from 'store/userClasses/selectors';
import { useAllBook } from 'store/books/selectors';
import VocabPrint from 'modules/PrintVocabulary/VocabPrint';
import { useLocation } from 'react-router-dom';
import { useMobileDetect } from 'hooks/useMobileDetect';
import { checkInappropriateContent } from 'utils/methods/word_filter';
import { handleAddInappropriateAlert } from 'store/logs/thunks';
import { useVoabPermissionForUser } from 'store/organizations/selectors';
import * as Sentry from '@sentry/react';
import AllPhrases from '../../../../components/AllPhrases';
import { useAlert } from '../../../../components/UI/alertSakeBar/alertProvider';
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import SentryWrap from 'components/Sentry';

const ModalContent = styled.div`
  position: relative;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  height: 100%;
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  z-index: 999999999;
`;

const ActionText = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
`;
const StyledTable = styled.table`
  width: 100%;
  max-height: 550px;
  border-collapse: collapse;
  td {
    border: 0.5px solid #fff;
  }
  th {
    border: 0.5px solid #fff;
  }
`;
const StyledHeader = styled.tr`
  position: sticky !important;
  top: 0;
  background-color: #fff;
  z-index: 10;
`;
const StyledTh = styled.th`
  background: #5d4187;
  color: #ffffff;
`;

const DROPDOWN_Z_INDEX = 1000000001;

const CrossPrint = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
`;

const Phrases = ({
  pageNumber,
  pageId,
  bookId,
  style,
  isCheckingOpen,
  setVocModal,
  vocabilaryButtonClassName = '',
  isVocabulary = false,
  isOnlyForTeacher = false,
}) => {
  const showAlert = useAlert();
  const { ref, isFocused } = useFocusOutside();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const bookPhrases = usePhrases();
  const classUsers = useClassUsers();
  const allBooks = useAllBook();
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const dispatch = useDispatch();
  const [openVocabulary, setVocabulary] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteVocab, setDeleteVocab] = useState({});
  const [addVocabData, setAddVocabData] = useState({});
  const [showWordLoader, setShowWordLoader] = useState(false);
  const [deleteVoc, setDeleteVoc] = useState(false);
  const [vocabularyAI, setVocabularyAI] = useState();

  const [getBooksPhrases, setGetBooksPhrases] = useState([]);
  const [newBooksPhrases, setNewBooksPhrases] = useState([]);
  const [studentCognates, setStudentCognates] = useState([]);
  const [phrasesLoader, setPhrasesLoader] = useState(false);

  const [getBooksPhrasesStd, setGetBooksPhrasesStd] = useState([]);
  const [newItem, setNewItem] = useState({ isEditable: true });
  const [selectedAIPhrases, setSelectedAIPhrases] = useState([]);
  const [assignmentAiModal, setAssignmentAiModal] = useState(false);
  const [generateQnALoader, setGenerateQnALoader] = useState(false);
  const [questionGenerator, setQuestionGenerator] = useState([]);
  const [questionLoader, setQuestionLoader] = useState(false);
  const [qnaWord, setQnAWord] = useState('');
  const [aiModal, setAiModal] = useState(false);
  const [studentWordCounts, setStudentWordCounts] = useState([]);
  const vocabdomRef = useRef();
  const exams = useExams();
  const isExam = useMemo(
    () =>
      exams?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)).includes(`${bookId}`),
    [exams],
  );
  const [tabSelector, setTabSelector] = useState({ type: 'page_phrases' });
  const isLandscape = useOrientation();
  const { stopAudio, setCurrentAudio } = useAudio();
  const [selectedWordCogantes, setSelectedWordCogantes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState(
    question_type_generate_more.map((option) => option.value),
  );
  const location = useLocation();
  const isMobile = useMobileDetect();
  const vocab_permission = useVoabPermissionForUser();
  const is_vocab_block_edit = useMemo(
    () => currentUser.role == 'student' && vocab_permission && vocab_permission.vocab,
    [vocab_permission, currentUser],
  );
  const [generatedCount, SetGenerateCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageStd, setCurrentPageStd] = useState(1);
  const itemsPerPage = 20;
  const current_book = useMemo(() => {
    return find(allBooks ?? [], ['id', bookId])?.subTopics || [];
  }, [allBooks, bookId]);

  const classStudents = filter(classUsers, (user) => user.role === 'student');
  const [showAccordin, setShowAccordin] = useState(true);
  const [dimensions, setDimensions] = useState({});
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleAudioChecker = async () => {
    stopAudio();
    setCurrentAudio(null);
    await dispatch(setAudioChecker({ isPlaying: false }));
  };

  useEffect(() => {
    const updateWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, []);

  const handleTouch = (event) => {
    event.preventDefault();
    handleVocabularyClose();
  };

  useEffect(() => {
    if (isCheckingOpen) {
      setVocabulary(true);
      setSelectedAIPhrases(getBooksPhrases || []);
      if (currentUser?.role === 'teacher') {
        const isPageSpecific =
          tabSelector?.type === 'page_phrases' || tabSelector?.type === 'my_phrases_stud';
        fetchStudentPhraseCounts(isPageSpecific);
      }
    } else {
      setVocabulary(false);
    }
  }, [isCheckingOpen]);
  useEffect(() => {
    if (tabSelector?.type === 'my_phrases_stud') return;
    if (currentUser.role == 'student') {
      const filterPhrases = filter(
        bookPhrases,
        (obj) =>
          obj.page == pageId && obj.created_by == 'student' && obj.user_id == currentUser?.id,
      );
      setGetBooksPhrasesStd(filterPhrases);
    }
    const filterPhrases = filter(bookPhrases, (obj) => obj.page == pageId);
    const filterByAdmin = filterPhrases?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filterPhrases?.filter((data) => data?.created_by === 'teacher') || [];
    const data = [];
    if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
    if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
    setNewBooksPhrases(data || []);
    setGetBooksPhrases(data || []);
  }, [bookPhrases, bookId, pageId]);

  useEffect(() => {
    if (openVocabulary && 
        (tabSelector?.type === "page_phrases" || tabSelector?.type === "unit_phrases") &&
        currentUser?.role === 'teacher' &&
        getBooksPhrases?.length > 0) {
        setSelectedAIPhrases(getBooksPhrases || []);
    }
  }, [getBooksPhrases, openVocabulary, pageId, tabSelector?.type, currentUser?.role])

  const onFilterPhrasesStd = () => {
    let sorted_obj = sortBy(bookPhrases, [
      function (o) {
        if (o.data && typeof o.data.phrase === 'string') {
          return o.data.phrase.toLowerCase();
        }
        return '';
      },
    ]);
    return sorted_obj;
  };

  useEffect(() => {
    setTimeout(() => {
      if (addVocabData.phrase == undefined) {
      } else {
        addPhrases();
      }
    }, 2000);
  }, [vocabularyAI]);

  useEffect(() => {
    const data = {
      teacher_id:
        currentUser.role == 'student'
          ? get(currentClass, 'teacherId', '')
          : get(currentUser, 'id', ''),
      user_id: get(currentUser, 'id', ''),
      created_by: currentUser.role == 'student' ? 'student' : 'teacher',
      class_id: currentUser.role == 'student' ? get(currentClass, 'id') : null,
      page: pageId,
      book_id: bookId,
    };
    Promise.allSettled([
      dispatch(handleListPhrasesNew(data, bookId, pageId, currentUser?.id)),
      dispatch(handleListPhrasesStud(data, bookId, pageId, currentUser?.id)),
    ]);
  }, []);

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: '', severity: 'success' });
  };
  const handleVocabularyClose = () => {
    handleAudioChecker();
    toogleChange('page_phrases');
    if (setVocModal) {
      setVocModal(false);
    }
    setVocabulary(false);
    setAddVocabData({});
    setVocabularyAI({});
    const dataToSend = getBooksPhrases.filter((item) => !item.isEditable);
    setGetBooksPhrases(dataToSend);
    
    // Reset to page phrases when closing
    const filterPhrases = filter(bookPhrases, (obj) => obj.page == pageId);
    const filterByAdmin = filterPhrases?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filterPhrases?.filter((data) => data?.created_by === 'teacher') || [];
    const data = [];
    if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
    if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
    setNewBooksPhrases(data || []);
    setGetBooksPhrases(data || []);
    
    dispatch(setDataPhrases(onFilterPhrasesStd()));
  };

  const toogleChange = (value) => {
    setTabSelector({ type: value });
    setCurrentPage(1);
    setCurrentPageStd(1);
  };

  const languageMenuItems = [
    {
      key: 'spanish',
      label: 'Spanish',
    },
    {
      key: 'english',
      label: 'English',
    },
  ];

  const handleCreateVocabularyQnA = async (_, count = 0, maxAttempts = 1, languageKey = 'spanish') => {
    try {
      const words = selectedAIPhrases.map((item) => item.data?.phrase);
      const data = words.join(', ');
      if (selectedAIPhrases?.length === 0 || data === '')
        return showAlert('Select atleast one phrase', 'info');
      if (count === 0) {
        setAssignmentAiModal(true);
        setGenerateQnALoader(true);
        handleVocabularyClose();
      }
      const generateLanguage = languageKey || 'spanish';
      await handleStreamResponse({
        path: 'ai/generate/generate-questions-for-vocab',
        body: JSON.stringify({
          topic: data,
          generate_question_language: generateLanguage,
        }),
        onTitle: (title) => {
          setQnAWord(title);
          SetGenerateCount(0);
        },
        onQuestion: (question) => {
          setQuestionGenerator((prev) => [
            ...prev,
            { ...question, id: Math.random() * 1000000000 },
          ]);
          SetGenerateCount((prev) => prev + 1);
          setQuestionLoader(false);
          setGenerateQnALoader(false);
        },
        onDone: () => {
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0);
        },
        onError: () => {
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0);
        },
      });
    } catch (error) {
      Sentry.captureException(`256 Error in handleCreateVocabularyQnA: ${error}`);
      console.log(error);
    }
  };

  const handleLanguageChange = ({ key }) => {
    handleCreateVocabularyQnA(null, 0, 1, key);
  };

  const handleGenerateMoreQnA = async (topic,key) => {
    setQuestionLoader(true);
    const words = selectedAIPhrases.map((item) => item.data?.phrase);
    const data = words.join(", ");
    await handleStreamResponse({
      path: 'ai/generate/generate-questions-for-vocab',
      body: JSON.stringify({
        topic: data,
        question_type: selectedTypes,
        generate_question_language: key
      }),
      onTitle: (title) => {
        setQnAWord(title);
        SetGenerateCount(0);
      },
      onQuestion: (question) => {
        setQuestionGenerator((prev) => [...prev, { ...question, id: Math.random() * 1000000000 }]);
        SetGenerateCount((prev) => prev + 1);
        setQuestionLoader(false);
        setGenerateQnALoader(false);
      },
      onDone: () => {
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0);
      },
      onError: () => {
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0);
      },
    });
  };

  const handleCheckboxChange = (checked, value) => {
    if (checked) {
      setSelectedAIPhrases((prev) => [...prev, value]);
    } else {
      setSelectedAIPhrases((prev) => prev.filter((item) => item.id !== value.id));
    }
  };

  const handleUpdateData = async (data) => {
    let datas = getBooksPhrases.find((item) => item.id === data?.id);
    await dispatch(handleCreatePhrases(datas));
    setAlertSakeBar({
      open: true,
      message: 'Updated Successfully',
      severity: 'success',
    });
  };

  const handleUpdateDataStd = async (data) => {
    let datas = getBooksPhrasesStd.find((item) => item.id === data?.id);
    await dispatch(handleCreatePhrases(datas));
    setAlertSakeBar({
      open: true,
      message: 'Updated Successfully',
      severity: 'success',
    });
  };

  const onDeleteVocab = async () => {
    await dispatch(handleDeletePhrases(deleteVocab?.id));
    setDeleteModal(false);
    setDeleteVoc(false);
    if (currentUser?.role === 'teacher') {
      const isPageSpecific =
        tabSelector?.type === 'page_phrases' || tabSelector?.type === 'my_phrases_stud';
      fetchStudentPhraseCounts(isPageSpecific);
    }
  };
  function editDataProperty(targetId, newValue, propertyName) {
    if (propertyName === 'phrase' && !validateWordLimit(newValue)) {
      const words = newValue.trim().split(/\s+/);
      const limitedValue = words.slice(0, 10).join(' ');
      const itemToEdit = getBooksPhrases.find((item) => item.id === targetId);
      const updatedData = getBooksPhrases.map((item) =>
        item.id === targetId
          ? {
              ...item,
              data: {
                ...item.data,
                [propertyName]: limitedValue,
              },
            }
          : item,
      );
      if (itemToEdit) {
        itemToEdit.data[propertyName] = limitedValue;
      }
      setGetBooksPhrases(updatedData);
      showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
      return;
    }
    const itemToEdit = getBooksPhrases.find((item) => item.id === targetId);
    const updatedData = getBooksPhrases.map((item) =>
      item.id === targetId
        ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: newValue,
            },
          }
        : item,
    );
    if (itemToEdit) {
      itemToEdit.data[propertyName] = newValue;
    }
    setGetBooksPhrases(updatedData);
  }

  function editDataPropertyStd(targetId, newValue, propertyName) {
    if (propertyName === 'phrase' && !validateWordLimit(newValue)) {
      const words = newValue.trim().split(/\s+/);
      const limitedValue = words.slice(0, 10).join(' ');
      const itemToEdit = getBooksPhrasesStd.find((item) => item.id === targetId);
      const updatedData = getBooksPhrasesStd.map((item) =>
        item.id === targetId
          ? {
              ...item,
              data: {
                ...item.data,
                [propertyName]: limitedValue,
              },
            }
          : item,
      );
      if (itemToEdit) {
        itemToEdit.data = itemToEdit?.data || {};
        itemToEdit.data[propertyName] = limitedValue;
      }
      setGetBooksPhrasesStd(updatedData);
      showAlert(`You can only enter up to 10 words in the phrase field`, 'warning');
      return;
    }
    const itemToEdit = getBooksPhrasesStd.find((item) => item.id === targetId);
    const updatedData = getBooksPhrasesStd.map((item) =>
      item.id === targetId
        ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: newValue,
            },
          }
        : item,
    );
    if (itemToEdit) {
      itemToEdit.data = itemToEdit?.data || {};
      itemToEdit.data[propertyName] = newValue;
    }
    setGetBooksPhrasesStd(updatedData);
  }

  const countWords = (text) => {
    if (!text || text.trim() === '') return 0;
    return text.trim().split(/\s+/).length;
  };

  const validateWordLimit = (text, maxWords = 10) => {
    const wordCount = countWords(text);
    return wordCount <= maxWords;
  };

  const handleAddPhraseData = (key, value) => {
    if (key == 'phrase') {
      if (!validateWordLimit(value)) {
        const words = value.trim().split(/\s+/);
        const limitedValue = words.slice(0, 10).join(' ');
        setAddVocabData({ ...addVocabData, [key]: limitedValue });
        showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
        return;
      }
      setAddVocabData({ ...addVocabData, [key]: value });
    } else {
      const v = vocabularyAI;
      vocabularyAI[key] = value;
      setVocabularyAI(v);
    }
  };
  const addPhrases = (phraseData) => {
    const dataToAdd = phraseData ? phraseData : vocabularyAI;
    const dataPhrase = {
      book_id: bookId,
      page: pageId,
      chapter: bookId,
      created_by: currentUser?.role,
      user_id: get(currentUser, 'id', ''),
      class_id: get(currentClass, 'id', ''),
      data: {
        phrase: addVocabData.phrase,
        ...dataToAdd,
      },
    };
    const result = dispatch(handleCreatePhrases(dataPhrase));
    setAlertSakeBar({
      open: true,
      message: 'Created Successfully',
      severity: 'success',
    });
    if (result) {
      setAddVocabData({});
      setVocabularyAI({});
    }
  };

  const callPhraseAI = async () => {
    if (addVocabData?.phrase) {
      setShowWordLoader(true);
      const ckeck_word = await checkInappropriateContent(addVocabData?.phrase, 'vocabulary');
      if (ckeck_word.containsInappropriate) {
        setShowWordLoader(false);
        handleAddInappropriateAlert(
          ckeck_word.foundWords,
          currentUser,
          currentClass,
          'phrases',
          addVocabData?.phrase,
        );
        return showAlert(
          `This phrase is not available in the dictionary. Please, try another phrase.`,
          'info',
        );
      }
      const result = await dispatch(
        handleGeneratePhrasesWithAI({
          topic: addVocabData?.phrase,
          book_id: bookId,
          page: pageId,
          chapter: bookId,
          created_by: currentUser?.role,
          user_id: get(currentUser, 'id', ''),
          class_id: get(currentClass, 'id', ''),
        }),
      );

      if (result && !result.error) {
        setAlertSakeBar({
          open: true,
          message: 'Created Successfully',
          severity: 'success',
        });
        if (vocabdomRef.current) {
          vocabdomRef.current.scrollTo(0, vocabdomRef.current.scrollHeight);
        }
      } else {
        setAlertSakeBar({
          open: true,
          message: 'No Result Found',
          severity: 'error',
        });
      }
      setAddVocabData({});
      setShowWordLoader(false);
    }
  };

  const addNewItem = () => {
    const isEditableItemExists = getBooksPhrases.some((item) => item.isEditable);
    if (!isEditableItemExists) {
      const updatedData = [...getBooksPhrases, newItem];
      setGetBooksPhrases(updatedData);
      const newItemIndex = updatedData.length - 1;
      const newPage = Math.ceil((newItemIndex + 1) / itemsPerPage);
      if (newPage > currentPage) {
        setCurrentPage(newPage);
      }
    }
  };

  const addNewItemForStd = () => {
    const isEditableItemExists = getBooksPhrasesStd.some((item) => item.isEditable);
    if (!isEditableItemExists) {
      const updatedData = [...getBooksPhrasesStd, newItem];
      setGetBooksPhrasesStd(updatedData);
      const newItemIndex = updatedData.length - 1;
      const newPage = Math.ceil((newItemIndex + 1) / itemsPerPage);
      if (newPage > currentPageStd) {
        setCurrentPageStd(newPage);
      }
    }
  };

  const handleForDistrictAdmin = () => {
    if (currentUser.role === 'admin') {
      setAlertSakeBar({ open: true, message: 'Please login as teacher!', severity: 'error' });
      return true;
    }
    return false;
  };

  const fetchStudentPhraseCounts = async (pageSpecific = true) => {
    try {
      const classId = get(currentClass, 'id');

      if (!classId || !bookId) {
        console.warn('Missing required parameters:', { classId, bookId });
        setStudentWordCounts([]);
        return [];
      }

      const data = {
        class_id: classId,
        book_id: bookId,
        ...(pageSpecific && { page: pageId }),
      };

      const counts = await dispatch(handleGetStudentPhraseCount(data));
      if (Array.isArray(counts)) {
        setStudentWordCounts(counts);
        return counts;
      } else {
        console.warn('Student phrase counts API returned non-array data:', counts);
        setStudentWordCounts([]);
        return [];
      }
    } catch (error) {
      console.error('Error fetching student phrase counts:', error);
      setStudentWordCounts([]);
      return [];
    }
  };

  const onCallStudentPhrases = async (id, type) => {
    setPhrasesLoader(true);
    const data = {
      teacher_id: get(currentUser, 'id', ''),
      user_id: id,
      created_by: 'teacher_student',
      page: pageId,
      book_id: bookId,
    };
    if (type === 'phrases') {
      const selectedStudentData = await dispatch(
        handleListPhrasesStud(data, bookId, pageId, currentUser?.id),
      );
      setGetBooksPhrases(selectedStudentData);
      setSelectedAIPhrases(Array.isArray(selectedStudentData) ? selectedStudentData : []);
    } else {
      const selectedStudentCognate = await dispatch(
        handleListVocabularyCogStud(data, bookId, pageId, currentUser?.id),
      );
      setStudentCognates(selectedStudentCognate);
    }
    setPhrasesLoader(false);
  };

  const getStudentPhraseCount = (studentId) => {
    if (!Array.isArray(studentWordCounts)) {
      return 0;
    }
    const student = studentWordCounts.find((s) => s.id === studentId);
    return student ? student.word_count : 0;
  };
  
  const items =
    classStudents && Array.isArray(classStudents)
      ? classStudents
          ?.map((item) => {
            const phraseCount = getStudentPhraseCount(item.id);
            return {
              key: item.id,
              label: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <span>{`${item.firstName} ${item.lastName}`}</span>
                  <span style={{
                    backgroundColor: '#5d4187',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    minWidth: '20px',
                    textAlign: 'center',
                    marginLeft: '8px'
                  }}>
                    {phraseCount}
                  </span>
                </div>
              ),
              phraseCount: phraseCount,
            };
          })
          .sort((a, b) => b.phraseCount - a.phraseCount)
      : [];

  const StudentPhrases = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleItemClick = (key) => {
      toogleChange(type === 'phrases' ? 'my_phrases_stud' : 'my_student_cog');
      onCallStudentPhrases(key, type);
      setIsOpen(false);
    };

    return (
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <Button
          className={`minWith ${tabSelector?.type === (type === 'phrases' ? 'my_phrases_stud' : 'my_student_cog') ? 'selected selected-background-color' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {type === 'phrases' ? 'Student Phrases' : 'Student Cognates'}
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button>

        {isOpen && (
          <div
            data-dropdown="true"
            className="dropdown-scrollable"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px',
              zIndex: 1000,
              minWidth: '200px',
              maxHeight: '200px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y'
            }}
          >
            {items.map((item) => (
              <div
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  ':hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {item.label}
                <span
                  style={{
                    backgroundColor: '#5d4187',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    minWidth: '20px',
                    textAlign: 'center',
                  }}
                >
                  {item.phraseCount}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const findPageObject = (pageID, data) => {
    return data.find(
      (item) =>
        Number(pageID) >= Number(item?.startPage) && Number(pageID) <= Number(item?.finishPage),
    );
  };

  const onManagePhrasesMenu = async (id, type) => {
    if (id === 'page_phrases') {
      toogleChange('page_phrases');
      setGetBooksPhrases(newBooksPhrases);
      setSelectedAIPhrases(newBooksPhrases || []);
    } else if (id === 'unit_phrases') {
      if (current_book?.length === 0) {
        showAlert('Unit not found in this book.', 'info');
        return;
      }
      toogleChange('unit_phrases');
      const findUnit = findPageObject(pageId, current_book);
      const filteredData = bookPhrases.filter((item) => {
        const pageNumber = parseInt(item.page, 10);
        return (
          pageNumber >= parseInt(findUnit?.startPage, 10) &&
          pageNumber <= parseInt(findUnit?.finishPage, 10)
        );
      });
      const filterByAdmin = filteredData?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filteredData?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [];
      if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
      if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
      setGetBooksPhrases(data);
      setSelectedAIPhrases(data || []);
    }
  };

  const unitExists = location.pathname === '/ebook' && findPageObject(pageId, current_book);
  const RenderMenuContent = () => {
    const menuItems = [
      ...(get(currentUser, 'role') === 'teacher'
        ? [
            {
              key: 'page_phrases',
              label: 'Page Phrases',
              onClick: () => onManagePhrasesMenu('page_phrases'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'teacher' && unitExists
        ? [
            {
              key: 'unit_phrases',
              label: 'Unit Phrases',
              onClick: () => onManagePhrasesMenu('unit_phrases'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'teacher' && !isExam && !isOnlyForTeacher
        ? [
            {
              key: 'ai_activity_vocab',
              label: 'AI Act. with Phrases',
              onClick: () => handleCreateVocabularyQnA(null, 0, 1, 'spanish'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'student'
        ? [
            {
              key: 'page_phrases',
              label: 'Page Phrases',
              onClick: () => toogleChange('page_phrases'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'student'
        ? [
            {
              key: 'my_phrases',
              label: 'My Phrases',
              onClick: () => toogleChange('my_phrases'),
            },
          ]
        : []),
    ];

    return menuItems.map((item) => ({
      key: item.key,
      label: <div onClick={item.onClick}>{item.label}</div>,
    }));
  };

  const handleItemClickStudentPhrases = (key) => {
    toogleChange('my_phrases_stud');
    onCallStudentPhrases(key?.key, 'phrases');
  };

  return (
    <SentryWrap>
      <div
        ref={ref}
        tabIndex={0}
        
      >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: '' });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <CognateAiLoader aiModal={aiModal} />
      <DeleteModal
        deleteToggle={deleteModal}
        loading={deleteVoc}
        onDelete={() => {
          onDeleteVocab();
          setDeleteVoc(true);
        }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove this ${deleteVocab?.data && deleteVocab?.data?.phrase ? `"${deleteVocab.data.phrase}"` : ''} phrase?`}
      />

      <Button
        style={{
          borderRadius: '0px !important',
          minWidth: 'unset',
          height: '36px',
          marginLeft: currentUser?.role === 'student' && 0,
          ...(style ? style : {}),
        }}
        onClick={() => {
          setVocabulary(!openVocabulary);
          setSelectedAIPhrases(getBooksPhrases || []);
          if (currentUser?.role === 'teacher') {
            const isPageSpecific =
              tabSelector?.type === 'page_phrases' || tabSelector?.type === 'my_phrases_stud';
            fetchStudentPhraseCounts(isPageSpecific);
          }
        }}
        className={`${isVocabulary ? 'videoSectionVocab' : `vocabularyBtn vocDeskTab scheduledWeb ${vocabilaryButtonClassName}`}`}
      >
        phrases
      </Button>
      {openVocabulary && (
            <ResizeAndDragabble
              style={{zIndex: 999999999}}
              defaultValue={{
                x: windowSize?.width < 768 ? (windowSize?.width - windowSize?.width * 0.7) / 2 : (windowSize?.width - Math.min(windowSize?.width - 40, 700)) / 2,
                y: windowSize?.height < 600 ? 10 : (windowSize?.height - Math.min(windowSize?.height - 40, 500)) / 2,
                width: windowSize?.width < 768 ? windowSize?.width * 0.7 : Math.min(windowSize?.width - 40, 700),
                height: windowSize?.height < 600 ? windowSize?.height * 0.7 : Math.min(windowSize?.height - 40, 500),
              }}
              size={dimensions?.width && dimensions?.height ? dimensions : undefined}
              minHeight={200}
              minWidth={windowSize?.width < 768 ? windowSize?.width * 0.5 : 300}
              maxWidth={windowSize?.width < 768 ? windowSize?.width : windowSize?.width - 40}
              maxHeight={windowSize?.width < 768 ? windowSize?.height * 0.8 : windowSize?.height - 60}
              resize={(data) => setDimensions(data)}
              resizeEnd={(data) => setDimensions(data)}
              aspectRatio={false}
            >
              <ModalContent isLandscape={isLandscape} className="111 vocabulContents vocabulContentsWidget phrasesWidget" style={{
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                zIndex: 999999999,
                position: "relative"
              }}>
                <div className="checkListFirstTxt absolute top-0 w-full pt-17px pb-14px br-topLeft-topRight-20px" style={{ pointerEvents: 'none' }}>
                  <span className="text-white text-ft12-700 phrasesTrack">Phrases</span>
                </div>
          <CrossPrint style={{ pointerEvents: 'auto' }}>
            <AIUsageInfo />
            {get(currentUser, 'role') === 'teacher' && (
              <VocabPrint
                data={
                  tabSelector?.type === 'congantes'
                    ? selectedWordCogantes
                    : tabSelector?.type === 'unit_cognates'
                      ? studentCognates
                      : tabSelector?.type === 'my_student_cog'
                        ? studentCognates
                        : getBooksPhrases
                }
                toggleType={tabSelector?.type}
              />
            )}
            <Close color="secondary" onClick={handleVocabularyClose} className="vocablaryClose" />
          </CrossPrint>
            <div className="VocabularyTabWidget VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px" style={{ pointerEvents: 'auto' }}>
              {/* Teacher View */}
              {get(currentUser, 'role') === 'teacher' && location.pathname === '/ebook' ? (
                <AllPhrases
                  type={''}
                  tabSelector={tabSelector}
                  onManagePhrasesMenu={onManagePhrasesMenu}
                  unitExists={unitExists}
                />
              ) : (
                <Button
                  className={
                    tabSelector?.type === 'page_phrases' ? 'selected selected-background-color' : ''
                  }
                  onClick={() => {
                    onManagePhrasesMenu('page_phrases');
                    toogleChange('page_phrases');
                  }}
                >
                  Page Phrases
                </Button>
              )}
              {get(currentUser, 'role') === 'teacher' && !isExam && !isOnlyForTeacher && (
                <Dropdown
                  menu={{ items: languageMenuItems, onClick: handleLanguageChange }}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                >
                  <Button
                    className="create-with-ai-button minWith"
                  >
                    AI Act. with Phrases
                    <KeyboardArrowDown />
                  </Button>
                </Dropdown>
              )}
              {/* {get(currentUser, 'role') === 'teacher' && <StudentPhrases type="phrases" />} */}
              {get(currentUser, 'role') === 'teacher' && (
                <Dropdown
                  menu={{ items: items, onClick: handleItemClickStudentPhrases }}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  dropdownRender={(menu) => (
                    <div style={{ maxHeight: '220px', overflowY: 'auto', borderRadius: 8 }}>
                      {menu}
                    </div>
                  )}
                >
                  <Button className={`minWith ${tabSelector?.type === 'my_phrases_stud' ? 'selected selected-background-color' : ''}`}>
                    Student Phrases
                    <KeyboardArrowDown />
                  </Button>
                </Dropdown>
              )}
              {get(currentUser, 'role') === 'student' && (
                <Button
                  className={
                    tabSelector?.type === 'my_phrases' ? 'selected selected-background-color' : ''
                  }
                  onClick={() => toogleChange('my_phrases')}
                >
                  My Phrases
                </Button>
              )}
            </div>
 
          <div
            className="111 vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth vocInMobileWidget dropdown-scrollable"
            data-dropdown="true"
            ref={vocabdomRef}
          >
            {(tabSelector?.type === 'page_phrases' ||
              tabSelector?.type === 'my_phrases_stud' ||
              tabSelector?.type === 'unit_phrases') && (
              <>
                <StyledTable border className="vocabulTable">
                  <thead>
                    <StyledHeader className="vocabulHeadTh">
                      {get(currentUser, 'role') === 'teacher' && !isExam && (
                        <StyledTh>Check</StyledTh>
                      )}
                      <StyledTh style={{ minWidth: 150, maxWidth: 250 }}>Phrase</StyledTh>
                      <StyledTh style={{ minWidth: 150 }}>Translation</StyledTh>
                      <StyledTh>Sentence in Spanish</StyledTh>
                      <StyledTh>Sentence in English</StyledTh>
                      <StyledTh>Actions</StyledTh>
                    </StyledHeader>
                  </thead>
                  {phrasesLoader ? (
                    <tbody>
                      <tr>
                        <td colSpan={get(currentUser, 'role') === 'teacher' && !isExam ? 8 : 7}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              minHeight: '60px',
                            }}
                          >
                            <Loading size={28} style={{ color: '#022b70' }} />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <>
                      {map(getBooksPhrases.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage), (value, k) => {
                        let data = get(value, 'data', '');
                        if (value?.created_by == 'student' && tabSelector?.type !== 'my_phrases_stud')
                          return;
                        const actualIndex = (currentPage - 1) * itemsPerPage + k;
                        return (
                          <tr className="vocabulHeadTr vocIcons" key={`${value.id || 'row'}-${actualIndex}`}>
                            {get(currentUser, 'role') === 'teacher' && !isExam && (
                              <td style={{ textAlign: 'center' }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <Checkbox
                                    disabled={!data?.phrase}
                                    onChange={(e) => handleCheckboxChange(e.target.checked, value)}
                                    checked={selectedAIPhrases.some((item) => item.id === value.id)}
                                  />
                                </div>
                              </td>
                            )}
                            <td style={{ minWidth: 150, maxWidth: 250 }}>
                              {value?.isEditable == true ? (
                                <div className="vocabInput">
                                  <InputArea
                                    value={addVocabData.phrase || ''}
                                    onPressEnter={() => {
                                      if (!showWordLoader) {
                                        callPhraseAI();
                                      }
                                    }}
                                    disabled={tabSelector?.type === 'my_phrases_stud'}
                                    onChange={(d) => {
                                      handleAddPhraseData('phrase', d.target.value.trimStart());
                                    }}
                                    placeholder="phrase"
                                    autoSize
                                    autoFocus
                                    style={{
                                      backgroundColor: 'transparent',
                                      borderColor: 'transparent',
                                      color: 'white',
                                      fontWeight: 200,
                                    }}
                                  />
                                  <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                    {showWordLoader ? (
                                      <Loading size={17} />
                                    ) : (
                                      <EnterOutlined
                                        disabled={showWordLoader}
                                        onClick={() => {
                                          if (!showWordLoader) {
                                            callPhraseAI();
                                          }
                                        }}
                                        style={{ fontSize: '25px' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <TextReader
                                    stopAudio={stopAudio}
                                    text={get(data, 'phrase', '')}
                                    language={'es-ES'}
                                    style={{ float: 'right' }}
                                  />
                                  <InputArea
                                    disabled={
                                      value?.created_by === 'owe_admin' ||
                                      currentUser?.role === 'student' ||
                                      value?.created_by === 'teacher' ||
                                      tabSelector?.type === 'my_phrases_stud'
                                    }
                                    value={get(data, 'phrase', '')}
                                    onChange={(d) =>
                                      editDataProperty(value.id, d.target.value.trimStart(), 'phrase')
                                    }
                                    placeholder="phrase"
                                    autoSize
                                    autoFocus
                                    style={{
                                      backgroundColor: 'transparent',
                                      borderColor: 'transparent',
                                      color: 'white',
                                      fontWeight: 200,
                                    }}
                                  />
                                </>
                              )}
                            </td>
                            <td>
                              <TextReader
                                stopAudio={stopAudio}
                                text={get(data, 'english_translation', '')}
                                language={'en-US'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateData(value);
                                }}
                                disabled={
                                  value?.created_by === 'owe_admin' ||
                                  (currentUser?.role === 'student' &&
                                    value?.created_by === 'teacher') ||
                                  tabSelector?.type === 'my_phrases_stud'
                                }
                                value={get(data, 'english_translation', '')}
                                onChange={(d) =>
                                  editDataProperty(
                                    value.id,
                                    d.target.value.trimStart(),
                                    'english_translation',
                                  )
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            <td>
                              <TextReader
                                stopAudio={stopAudio}
                                text={get(data, 'sentence', '')}
                                language={'es-ES'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateData(value);
                                }}
                                disabled={
                                  value?.created_by === 'owe_admin' ||
                                  (currentUser?.role === 'student' &&
                                    value?.created_by === 'teacher') ||
                                  tabSelector?.type === 'my_phrases_stud'
                                }
                                value={get(data, 'sentence', '')}
                                onChange={(d) =>
                                  editDataProperty(value.id, d.target.value.trimStart(), 'sentence')
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            <td>
                              <TextReader
                                stopAudio={stopAudio}
                                text={get(data, 'sentence_english', '')}
                                language={'en-US'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateData(value);
                                }}
                                disabled={
                                  value?.created_by === 'owe_admin' ||
                                  (currentUser?.role === 'student' &&
                                    value?.created_by === 'teacher') ||
                                  tabSelector?.type === 'my_phrases_stud'
                                }
                                value={get(data, 'sentence_english', '')}
                                onChange={(d) =>
                                  editDataProperty(value.id, d.target.value.trimStart(), 'sentence_english')
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            {get(currentUser, 'role') == 'student' ? (
                              <>
                                <td style={{ textAlign: 'center' }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <ActionText>
                                      {value?.created_by === 'owe_admin' ? 'Admin' : 'Teacher'}
                                    </ActionText>
                                  </div>
                                </td>
                              </>
                            ) : (
                              <>
                                {value?.created_by !== 'owe_admin' &&
                                tabSelector?.type !== 'my_phrases_stud' ? (
                                  <td style={{ textAlign: 'center' }}>
                                    {data?.phrase ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <Delete
                                          style={{ fontSize: '20px' }}
                                          onClick={() => {
                                            setDeleteModal(true);
                                            setDeleteVocab(value);
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                  </td>
                                ) : tabSelector?.type === 'my_phrases_stud' ? (
                                  <td style={{ textAlign: 'center' }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <ActionText>Student</ActionText>
                                    </div>
                                  </td>
                                ) : (
                                  <td style={{ textAlign: 'center' }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <ActionText>Admin</ActionText>
                                    </div>
                                  </td>
                                )}
                              </>
                            )}
                          </tr>
                        );
                      })}
                      {get(currentUser, 'role') !== 'student' &&
                        tabSelector?.type !== 'my_phrases_stud' &&
                        tabSelector?.type !== 'unit_phrases' && (
                          <tr className="vocabulHeadTr">
                            {get(currentUser, 'role') === 'teacher' && !isExam && <td></td>}
                            <td>
                              <IconButton>
                                <Add
                                  style={{ fontSize: '18px' }}
                                  onClick={() => {
                                    if (handleForDistrictAdmin()) return;
                                    addNewItem();
                                  }}
                                />
                              </IconButton>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      {phrasesLoader ? (
                        <Loading size={28} style={{ color: '#022b70' }} />
                      ) : (
                        <>
                          {getBooksPhrases?.length === 0 && (
                            <tr>
                              <td
                                colSpan={get(currentUser, 'role') === 'teacher' && !isExam ? 8 : 7}
                                style={{ border: 'none' }}
                              >
                                <p
                                  style={{
                                    fontWeight: 200,
                                    paddingTop: '5px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}
                                >
                                  No Phrases available in this section.
                                </p>
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </>
                  )}
                </StyledTable>
                {getBooksPhrases.length > itemsPerPage && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px', marginTop: '15px' }}>
                    <IconButton 
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                      size="small"
                      style={{ color: 'white' }}
                    >
                      <ChevronLeft />
                    </IconButton>
                    <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
                      Page {currentPage} of {Math.ceil(getBooksPhrases.length / itemsPerPage)} ({getBooksPhrases.length} items)
                    </span>
                    <IconButton 
                      disabled={currentPage >= Math.ceil(getBooksPhrases.length / itemsPerPage)}
                      onClick={() => setCurrentPage(prev => Math.min(Math.ceil(getBooksPhrases.length / itemsPerPage), prev + 1))}
                      size="small"
                      style={{ color: 'white' }}
                    >
                      <ChevronRight />
                    </IconButton>
                  </div>
                )}
              </>
            )}

            {tabSelector?.type === 'my_phrases' && get(currentUser, 'role') === 'student' && (
              <>
                <StyledTable border className="vocabulTable">
                  <StyledHeader className="vocabulHeadTh">
                    <StyledTh style={{ minWidth: 150, maxWidth: 250 }}>Phrase</StyledTh>
                    <StyledTh style={{ minWidth: 150 }}>Translation</StyledTh>
                    <StyledTh>Sentence in Spanish</StyledTh>
                    <StyledTh>Sentence in English</StyledTh>
                    <StyledTh>Actions</StyledTh>
                  </StyledHeader>
                  {phrasesLoader ? (
                    <tbody>
                      <tr>
                        <td colSpan={5} style={{ border: 'none' }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              minHeight: '60px',
                            }}
                          >
                            <Loading size={28} style={{ color: '#022b70' }} />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <>
                      {map(getBooksPhrasesStd.slice((currentPageStd - 1) * itemsPerPage, currentPageStd * itemsPerPage), (value, k) => {
                        let data = get(value, 'data', '');
                        const actualIndex = (currentPageStd - 1) * itemsPerPage + k;
                        return (
                          <tr className="vocabulHeadTr vocIcons" key={`${value.id || 'row'}-${actualIndex}`}>
                            <td style={{ minWidth: 150, maxWidth: 250 }}>
                              {value?.isEditable == true ? (
                                <div className="vocabInput">
                                  <InputArea
                                    value={addVocabData.phrase || ''}
                                    onPressEnter={() => {
                                      if (!showWordLoader) {
                                        callPhraseAI();
                                      }
                                    }}
                                    onChange={(d) => {
                                      handleAddPhraseData('phrase', d.target.value.trimStart());
                                    }}
                                    placeholder="phrase"
                                    autoSize
                                    autoFocus
                                    style={{
                                      backgroundColor: 'transparent',
                                      borderColor: 'transparent',
                                      color: 'white',
                                      fontWeight: 200,
                                    }}
                                  />
                                  <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                    {showWordLoader ? (
                                      <Loading size={17} />
                                    ) : (
                                      <EnterOutlined
                                        disabled={showWordLoader}
                                        onClick={() => {
                                          if (!showWordLoader) {
                                            callPhraseAI();
                                          }
                                        }}
                                        style={{ fontSize: '25px' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <TextReader
                                    stopAudio={stopAudio}
                                    text={get(data, 'phrase', '')}
                                    language={'es-ES'}
                                    style={{ float: 'right' }}
                                  />
                                  <InputArea
                                    disabled={
                                      value?.created_by === 'owe_admin' ||
                                      currentUser?.role === 'student' ||
                                      value?.created_by === 'teacher'
                                    }
                                    value={get(data, 'phrase', '')}
                                    onChange={(d) =>
                                      editDataPropertyStd(
                                        value.id,
                                        d.target.value.trimStart(),
                                        'phrase',
                                      )
                                    }
                                    placeholder="phrase"
                                    autoSize
                                    style={{
                                      backgroundColor: 'transparent',
                                      borderColor: 'transparent',
                                      color: 'white',
                                      fontWeight: 200,
                                    }}
                                  />
                                </>
                              )}
                            </td>
                            <td>
                              <TextReader
                                stopAudio={stopAudio}
                                text={get(data, 'english_translation', '')}
                                language={'en-US'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateDataStd(value);
                                }}
                                disabled={is_vocab_block_edit}
                                value={get(data, 'english_translation', '')}
                                onChange={(d) =>
                                  editDataPropertyStd(
                                    value.id,
                                    d.target.value.trimStart(),
                                    'english_translation',
                                  )
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            <td>
                              <TextReader
                                stopAudio={stopAudio}
                                text={get(data, 'sentence', '')}
                                language={'es-ES'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateDataStd(value);
                                }}
                                disabled={is_vocab_block_edit}
                                value={get(data, 'sentence', '')}
                                onChange={(d) =>
                                  editDataPropertyStd(
                                    value.id,
                                    d.target.value.trimStart(),
                                    'sentence',
                                  )
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            <td>
                              <TextReader
                                text={get(data, 'sentence_english', '')}
                                language={'en-US'}
                                style={{ float: 'right' }}
                              />
                              <TextArea
                                onBlur={() => {
                                  handleUpdateDataStd(value);
                                }}
                                value={get(data, 'sentence_english', '')}
                                onChange={(d) =>
                                  editDataPropertyStd(
                                    value.id,
                                    d.target.value.trimStart(),
                                    'sentence_english',
                                  )
                                }
                                autoSize
                                style={{
                                  backgroundColor: 'transparent',
                                  borderColor: 'transparent',
                                  color: 'white',
                                  fontWeight: 200,
                                  padding: 0,
                                }}
                              />
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {data?.phrase && (
                                  <Delete
                                    style={{ fontSize: 20 }}
                                    onClick={() => {
                                      setDeleteModal(true);
                                      setDeleteVocab(value);
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                      <tr className="vocabulHeadTr">
                        <td>
                          <IconButton>
                            {!is_vocab_block_edit ? (
                              <Add
                                style={{ fontSize: '18px' }}
                                onClick={() => {
                                  if (handleForDistrictAdmin()) return;
                                  addNewItemForStd();
                                }}
                              />
                            ) : null}
                          </IconButton>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      {phrasesLoader ? (
                        <Loading size={28} style={{ color: '#022b70' }} />
                      ) : (
                        <>
                          {getBooksPhrasesStd?.length === 0 && (
                            <tr>
                              <td colSpan={5} style={{ border: 'none' }}>
                                <p
                                  style={{
                                    fontWeight: 200,
                                    paddingTop: '5px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}
                                >
                                  No Phrases available in this section.
                                </p>
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </>
                  )}
                </StyledTable>
                {getBooksPhrasesStd.length > itemsPerPage && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px', marginTop: '15px' }}>
                    <IconButton 
                      disabled={currentPageStd === 1}
                      onClick={() => setCurrentPageStd(prev => Math.max(1, prev - 1))}
                      size="small"
                      style={{ color: 'white' }}
                    >
                      <ChevronLeft />
                    </IconButton>
                    <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
                      Page {currentPageStd} of {Math.ceil(getBooksPhrasesStd.length / itemsPerPage)} ({getBooksPhrasesStd.length} items)
                    </span>
                    <IconButton 
                      disabled={currentPageStd >= Math.ceil(getBooksPhrasesStd.length / itemsPerPage)}
                      onClick={() => setCurrentPageStd(prev => Math.min(Math.ceil(getBooksPhrasesStd.length / itemsPerPage), prev + 1))}
                      size="small"
                      style={{ color: 'white' }}
                    >
                      <ChevronRight />
                    </IconButton>
                  </div>
                )}
              </>
            )}
                </div>
              </ModalContent>
            </ResizeAndDragabble>
      )}
      {assignmentAiModal && (
        <QnALoader
          assignmentAiModal={assignmentAiModal}
          setAssignmentAiModal={setAssignmentAiModal}
          handleGenerateMoreQnA={handleGenerateMoreQnA}
          generateQnALoader={generateQnALoader}
          questionGenerator={questionGenerator}
          page={pageId}
          chapter={bookId}
          qnaWord={qnaWord}
          loading={questionLoader}
          pageNumber={pageNumber}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
          generatedCount={generatedCount}
          from="phrases"
        />
      )}
      </div>
    </SentryWrap>
  );
};


export default Phrases;
